"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsonpath_plus_1 = require("jsonpath-plus");
const TezosTypes = __importStar(require("../../../types/tezos/TezosChainTypes"));
const TezosConstants_1 = require("../../../types/tezos/TezosConstants");
const TezosNodeReader_1 = require("../TezosNodeReader");
const TezosNodeWriter_1 = require("../TezosNodeWriter");
const TezosContractUtils_1 = require("./TezosContractUtils");
var BabylonDelegationHelper;
(function (BabylonDelegationHelper) {
    function verifyDestination(server, address) {
        return __awaiter(this, void 0, void 0, function* () {
            return TezosContractUtils_1.TezosContractUtils.verifyDestination(server, address, 'd99cb8b4c7e40166f59c0f3c30724225');
        });
    }
    BabylonDelegationHelper.verifyDestination = verifyDestination;
    function verifyScript(script) {
        return TezosContractUtils_1.TezosContractUtils.verifyScript(script, 'a585489ffaee60d07077059539d5bfc8');
    }
    BabylonDelegationHelper.verifyScript = verifyScript;
    function getSimpleStorage(server, address) {
        return __awaiter(this, void 0, void 0, function* () {
            const storageResult = yield TezosNodeReader_1.TezosNodeReader.getContractStorage(server, address);
            return { administrator: jsonpath_plus_1.JSONPath({ path: '$.string', json: storageResult })[0] };
        });
    }
    BabylonDelegationHelper.getSimpleStorage = getSimpleStorage;
    function setDelegate(server, signer, keyStore, contract, delegate, fee) {
        if (contract.startsWith('KT1')) {
            const parameters = `[{ "prim": "DROP" }, { "prim": "NIL", "args": [{ "prim": "operation" }] }, { "prim": "PUSH", "args": [{ "prim": "key_hash" }, { "string": "${delegate}" } ] }, { "prim": "SOME" }, { "prim": "SET_DELEGATE" }, { "prim": "CONS" } ]`;
            return TezosNodeWriter_1.TezosNodeWriter.sendContractInvocationOperation(server, signer, keyStore, contract, 0, fee, 0, TezosConstants_1.TezosConstants.P005ManagerContractWithdrawalGasLimit, 'do', parameters, TezosTypes.TezosParameterFormat.Micheline);
        }
        else {
            return TezosNodeWriter_1.TezosNodeWriter.sendDelegationOperation(server, signer, keyStore, delegate, fee);
        }
    }
    BabylonDelegationHelper.setDelegate = setDelegate;
    function unSetDelegate(server, signer, keyStore, contract, fee) {
        if (contract.startsWith('KT1')) {
            const parameters = `[{ "prim": "DROP" }, { "prim": "NIL", "args": [{ "prim": "operation" }] }, { "prim": "NONE", "args": [{ "prim": "key_hash" }] }, { "prim": "SET_DELEGATE" }, { "prim": "CONS" } ]`;
            return TezosNodeWriter_1.TezosNodeWriter.sendContractInvocationOperation(server, signer, keyStore, contract, 0, fee, 0, TezosConstants_1.TezosConstants.P005ManagerContractWithdrawalGasLimit, 'do', parameters, TezosTypes.TezosParameterFormat.Micheline);
        }
        else {
            return TezosNodeWriter_1.TezosNodeWriter.sendUndelegationOperation(server, signer, keyStore, fee);
        }
    }
    BabylonDelegationHelper.unSetDelegate = unSetDelegate;
    function withdrawDelegatedFunds(server, signer, keyStore, contract, fee, amount) {
        return sendDelegatedFunds(server, signer, keyStore, contract, fee, amount, keyStore.publicKeyHash);
    }
    BabylonDelegationHelper.withdrawDelegatedFunds = withdrawDelegatedFunds;
    function sendDelegatedFunds(server, signer, keyStore, contract, fee, amount, destination) {
        let parameters = `[ { "prim": "DROP" },
            { "prim": "NIL", "args": [ { "prim": "operation" } ] },
            { "prim": "PUSH", "args": [ { "prim": "key_hash" }, { "string": "${destination}" } ] },
            { "prim": "IMPLICIT_ACCOUNT" },
            { "prim": "PUSH", "args": [ { "prim": "mutez" }, { "int": "${amount}" } ] },
            { "prim": "UNIT" },
            { "prim": "TRANSFER_TOKENS" },
            { "prim": "CONS" } ]`;
        return TezosNodeWriter_1.TezosNodeWriter.sendContractInvocationOperation(server, signer, keyStore, contract, 0, fee, TezosConstants_1.TezosConstants.P005ManagerContractWithdrawalStorageLimit, TezosConstants_1.TezosConstants.P005ManagerContractWithdrawalGasLimit, 'do', parameters, TezosTypes.TezosParameterFormat.Micheline);
    }
    BabylonDelegationHelper.sendDelegatedFunds = sendDelegatedFunds;
    function depositDelegatedFunds(server, signer, keyStore, contract, fee, amount) {
        return TezosNodeWriter_1.TezosNodeWriter.sendContractInvocationOperation(server, signer, keyStore, contract, amount, fee, 0, TezosConstants_1.TezosConstants.P005ManagerContractDepositGasLimit, undefined, undefined);
    }
    BabylonDelegationHelper.depositDelegatedFunds = depositDelegatedFunds;
    function deployManagerContract(server, signer, keyStore, delegate, fee, amount, optimizeFee = false) {
        const code = `[ { "prim": "parameter",
        "args":
          [ { "prim": "or",
              "args":
                [ { "prim": "lambda",
                    "args":
                      [ { "prim": "unit" }, { "prim": "list", "args": [ { "prim": "operation" } ] } ], "annots": [ "%do" ] },
                  { "prim": "unit", "annots": [ "%default" ] } ] } ] },
      { "prim": "storage", "args": [ { "prim": "key_hash" } ] },
      { "prim": "code",
        "args":
          [ [ [ [ { "prim": "DUP" }, { "prim": "CAR" },
                  { "prim": "DIP", "args": [ [ { "prim": "CDR" } ] ] } ] ],
              { "prim": "IF_LEFT",
                "args":
                  [ [ { "prim": "PUSH", "args": [ { "prim": "mutez" }, { "int": "0" } ] },
                      { "prim": "AMOUNT" },
                      [ [ { "prim": "COMPARE" }, { "prim": "EQ" } ],
                        { "prim": "IF", "args": [ [], [ [ { "prim": "UNIT" }, { "prim": "FAILWITH" } ] ] ] } ],
                      [ { "prim": "DIP", "args": [ [ { "prim": "DUP" } ] ] },
                        { "prim": "SWAP" } ],
                      { "prim": "IMPLICIT_ACCOUNT" },
                      { "prim": "ADDRESS" },
                      { "prim": "SENDER" },
                      [ [ { "prim": "COMPARE" }, { "prim": "EQ" } ],
                        { "prim": "IF", "args": [ [], [ [ { "prim": "UNIT" },{ "prim": "FAILWITH" } ] ] ] } ],
                      { "prim": "UNIT" }, { "prim": "EXEC" },
                      { "prim": "PAIR" } ],
                    [ { "prim": "DROP" },
                      { "prim": "NIL", "args": [ { "prim": "operation" } ] },
                      { "prim": "PAIR" } ] ] } ] ] } ]`;
        const storage = `{ "string": "${keyStore.publicKeyHash}" }`;
        return TezosNodeWriter_1.TezosNodeWriter.sendContractOriginationOperation(server, signer, keyStore, amount, delegate, fee, 600, 20000, code, storage, TezosTypes.TezosParameterFormat.Micheline, TezosConstants_1.TezosConstants.HeadBranchOffset, optimizeFee);
    }
    BabylonDelegationHelper.deployManagerContract = deployManagerContract;
})(BabylonDelegationHelper = exports.BabylonDelegationHelper || (exports.BabylonDelegationHelper = {}));
//# sourceMappingURL=BabylonDelegationHelper.js.map